import { rei } from "@/services/api"
import moment from "moment/moment"
import {transformSearchedRascunho} from "@/utils/itemRascunho"

class BuscaService {
  static searchREI (params) {
    try {
      return rei.get(`registros`, { params })
    } catch (error) {
      return {
        "data": {
          error: error,
          "total": 0,
          "perPage": 0,
          "page": 0,
          "lastPage": 0,
          "data": []
        }
      }
    }
  }

  static async searchMedico (crm = '', uf = '') {
    try {
      loader({ text: '', active: true })

      const { data } = await rei.get(`buscar-medico?crm=${crm}&uf=${uf}`)

      return data || {}
    } catch (error) {
      return { error }
    } finally {
      loader({ text: '', active: false })
    }
  }

  static searchRascunhoREI (params) {
    try {
      return rei.get(`registros-rascunho`, { params })
    } catch (error) {
      return {
        "data": {
          error: error,
          "total": 0,
          "perPage": 0,
          "page": 0,
          "lastPage": 0,
          "data": []
        }
      }
    }
  }

  static async searchRascunhoBeforeSave (registro, pessoa) {
    const payload = {
      nome: pessoa.nome ? pessoa.nome : pessoa.nome_antigo ? pessoa.nome_antigo : '',
      cartorio_id: registro.cartorio_id ? registro.cartorio_id : '',
      tipo_registro: registro.tipo_registro ? registro.tipo_registro : '',
      data_ocorrido_inicio: registro.tipo_registro === 'N' && pessoa.data_nascimento ? moment(pessoa.data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
      data_ocorrido_fim: registro.tipo_registro === 'N' && pessoa.data_nascimento ? moment(pessoa.data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
      cpf: pessoa.cpf ? pessoa.cpf : null,
      perPage: 3,
      natimorto: pessoa.natimorto ? pessoa.natimorto : '',
    }

    const {data} = await BuscaService.searchRascunhoREI(payload)

    if (data.total > 0 && data.docs.length) {
      let result = {data: []}

      result.searchParams = payload
      result.page = data.page
      result.total = data.total
      result.perPage = data.limit
      result.lastPage = data.pages
      result.data = data.docs.map((item) => transformSearchedRascunho(item))

      return result

    } else {
      return false
    }
  }
}

export default BuscaService
